import { TCsx } from '@emotion/react';
import { layoutGridStyles } from './styles';

interface ILayoutGrid {
  height: number | string;
  columns?: number;
  squareSize?: number;
  csx?: TCsx;
  showGridLines?: boolean;
  showBorder?: boolean;
}

const LayoutGrid = ({
  height,
  columns = 12,
  csx,
  showGridLines,
  squareSize,
  showBorder = false,
}: ILayoutGrid) => {
  // Redux
  const SQUARE_SIZE_BIG = squareSize || 50;
  return (
    <div
      css={[
        layoutGridStyles(
          SQUARE_SIZE_BIG,
          height,
          columns,
          showGridLines,
          showBorder,
        ),
        csx,
      ]}
    />
  );
};

export default LayoutGrid;
